import Vue from 'vue'
import Vuex from 'vuex'
import Cookie from 'vue-cookies'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    usercode: Cookie.get('usercode'),
    token: Cookie.get('token'),
    showlogin: 0,
    islogin: false
  },
  mutations: {
    // 组件中通过 this.$store.commit(参数)  调用
    saveToken: function (state, data) {
      state.usercode = data.usercode
      state.token = data.token
      Cookie.set('usercode', data.usercode, '24h')
      Cookie.set('token', data.token, '24h')
    },
    clearToken: function (state) {
      state.usercode = null
      state.token = null
      Cookie.remove('usercode')
      Cookie.remove('token')
    },
    updateShowlogin: function (state) {
      state.showlogin = new Date().valueOf()
    },
    logined: function (state, login) {
      state.islogin = login
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js